// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-create-application-location-rc) {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.map-row {
  min-height: 37vh;
  max-height: 70vh;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.remove-button {
  margin-left: 10px;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
}

.missing-zones-label {
  font-size: 13px;
  color: #000000;
  padding: 0;
}

.row-padding {
  padding-right: 0%;
}

.propertypadding {
  margin-top: 15px;
}

input:disabled {
  background-color: lightgray !important;
}

.grey-out {
  background-color: lightgray !important;
  opacity: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
